import React, { useEffect, useState } from "react"
import { Fragment } from "react"
import { Button, Col, Form, Row, Table } from "react-bootstrap"
import { useNavigate, useParams } from "react-router-dom"
import toast from "react-hot-toast"
import Select from "react-select"
import ReactLoading from "react-loading"
import Modal from "antd/es/modal/Modal"
import Upload from "antd/es/upload/Upload"
// api
import { getAllForwarders } from "../../../../Helpers/apiCalls/forwardersApi"
import { validateSePurchaseInvoice } from "../../../../Helpers/Validation/Purchase/SEPIValidation"

// assets & styles
import {
  capitalizeFirstLetter,
  getTodayDateISO,
  numberFormat,
  toastStyle,
  TokenExpiry,
} from "../../../../Helpers/Utils/Common"
import {
  createSEPurchaseInvoice,
  getSingleSEPurchaseInvoice,
  getSingleSEPurchaseOrder,
  updateSEPurchaseInvoice,
  deleteSeAttachment,
} from "../../../../Helpers/apiCalls/Expenses/sePurchaseApi"
import { getAllBranches } from "../../../../Helpers/apiCalls/Purchases/suppliesExpensesApi"
import trash from "./../../../../Assets/Images/trash.png"
import Navbar from "../../../../Components/Navbar/Navbar"
import "./../../PurchaseOrders/PurchaseOrders.css"
import "./../PurchaseInvoices.css"
import InputError from "../../../../Components/InputError/InputError"
import upload from "../../../../Assets/Images/upload.png"
import moment from "moment"
import FileExceedModal from "../../../../Components/Modals/FileExceedModal"
import Compressor from "compressorjs"
import noDataImg from "../../../../Assets/Images/no-data-img.png"
import Footer from "../../../../Components/Footer/Footer"

function SEFormPurchaseInvoice({ add, edit }) {
  let navigate = useNavigate()
  const { Dragger } = Upload
  const [inactive, setInactive] = useState(true)
  const [isChanged, setIsChanged] = useState(false)

  /**
   *  @po_id - param for add purchase invoice form
   *  @pi_id - param for edit purchase invoice form
   */
  const { po_id, pi_id } = useParams()

  // PURCHASE INVOICE DETAILS HANDLER
  const [addPI, setAddPI] = useState({
    due_date: getTodayDateISO(),
  })
  const [itemList, setItemList] = useState([])
  const [additionalItemList, setAdditionalItemList] = useState([])
  const [branches, setBranches] = useState([])
  const [isClicked, setIsClicked] = useState(false)
  const [typeValue, setTypeValue] = useState({
    name: "type",
    label: addPI.type,
    value: addPI.expense_type_id,
  })
  const [branchValue, setBranchValue] = useState({
    name: "branch_id",
    label: "",
    value: "",
  })

  const typeOptions = [
    {
      id: 1,
      name: "type",
      value: "Transportation",
      label: "Transportation",
    },
    {
      id: 2,
      name: "type",
      value: "Kiosk construction",
      label: "Kiosk Construction",
    },
    {
      id: 3,
      name: "type",
      value: "Office supplies",
      label: "Office Supplies",
    },
    {
      id: 4,
      name: "type",
      value: "Store supplies",
      label: "Store Supplies",
    },
    {
      id: 5,
      name: "type",
      value: "Rental",
      label: "Rental",
    },
    {
      id: 6,
      name: "type",
      value: "CUSA + Aircon",
      label: "CUSA + Aircon",
    },
    {
      id: 7,
      name: "type",
      value: "Salaries + 13th Month",
      label: "Salaries + 13th Month",
    },
    {
      id: 8,
      name: "type",
      value: "Benefits - Employer Share",
      label: "Benefits - Employer Share",
    },
    {
      id: 9,
      name: "type",
      value: "Professional Fees",
      label: "Professional Fees",
    },
    {
      id: 10,
      name: "type",
      value: "Repairs and Maintenance",
      label: "Repairs and Maintenance",
    },
    {
      id: 11,
      name: "type",
      value: "Communication",
      label: "Communication",
    },
    {
      id: 12,
      name: "type",
      value: "Insurance",
      label: "Insurance",
    },
    {
      id: 13,
      name: "type",
      value: "Pest Control",
      label: "Pest Control",
    },
    {
      id: 14,
      name: "type",
      value: "Logistics",
      label: "Logistics",
    },
    {
      id: 15,
      name: "type",
      value: "Rental - Payable from Sales",
      label: "Rental - Payable from Sales",
    },
    {
      id: 16,
      name: "type",
      value: "Marketing",
      label: "Marketing",
    },
    {
      id: 17,
      name: "type",
      value: "Permits & Liscense Renewal",
      label: "Permits & Liscense Renewal",
    },
    {
      id: 18,
      name: "type",
      value: "Operating Supplies",
      label: "Operating Supplies",
    },
    {
      id: 19,
      name: "type",
      value: "Others",
      label: "Others",
    },
    {
      id: 20,
      name: "type",
      value: "Water",
      label: "Water",
    },
    {
      id: 21,
      name: "type",
      value: "Electricity",
      label: "Electricity",
    },
    {
      id: 22,
      name: "type",
      value: "Taxes",
      label: "Taxes",
    },
    {
      id: 23,
      name: "type",
      value: "Refund",
      label: "Refund",
    },
  ]

  //ERROR HANDLING
  const [isError, setIsError] = useState({
    received_date: false,
    invoice_no: false,
    dr_no: false,
    // items
    qtyInput: false, //receive tbl
    price: false, //receive tbl
    item_id: false, //additional tbl
    qty: false, //additional tbl
    addtl_price: false, //additional tbl
  })

  // DATA HANDLERS
  const [forwarders, setForwarders] = useState([])
  const [forwarderValue, setForwarderValue] = useState({
    name: "forwarder_id",
    label: "",
    value: "",
  })

  const [file, setFile] = useState("")
  const [fileList, setFileList] = useState([])
  const [preview, setPreview] = useState(false)
  const [previewFile, setPreviewFile] = useState("")
  const [prevAttachments, setPrevAttachments] = useState([])
  const [showFileExceedModal, setShowFileExceedModal] = useState(false)

  const handleRemove = (selectedFile) => {
    var newlist = fileList.filter((file) => {
      return selectedFile.uid !== file.uid
    })
    setFileList(newlist)
  }

  const handleBeforeUpload = (file) => {
    if (file.size > 2000000) {
      setShowFileExceedModal(true)
    } else {
      //COMPRESSING FILE
      new Compressor(file, {
        quality: 0.6,
        success: (compressedResult) => {
          setFileList([...fileList, compressedResult])
        },
      })
    }
    return false
  }

  function handleRemoveItemAttachment(url) {
    var newList = prevAttachments.filter((data) => {
      return data.file_url !== url
    })
    setPrevAttachments(newList)
    setPreview(false)
  }

  function handleType(e) {
    // var newList = addPI;
    var newList = { ...addPI }
    newList[e.name] = e.value
    setAddPI(newList)
    setTypeValue({ name: e.name, label: e.label, value: e.value })
  }
  function handleForwarderChange(e) {
    // var newList = addPI;
    var newList = { ...addPI }
    newList[e.name] = e.value
    setAddPI(newList)
    setForwarderValue({ name: e.name, label: e.label, value: e.value })
  }

  function handleBranchChange(e) {
    setBranchValue({ name: e.name, label: e.label, value: e.value })
    setAddPI((prev) => ({
      ...prev,
      branch_id: e.value,
    }))
  }

  function handleAddChange(e) {
    setIsChanged(true)
    const { name, value, checked } = e.target
    if (name === "is_vat") {
      setAddPI((prevState) => ({
        ...prevState,
        [name]: checked,
        ["vat_type"]: checked ? "VAT" : "NVAT",
        ["withholding_percentage"]: !checked
          ? 0
          : addPI.original_withholding_percentage,
      }))
    } else if (name === "withholding_percentage") {
      setAddPI((prevState) => ({
        ...prevState,
        ["withholding_percentage"]: value === "1" ? 1 : 2,
      }))
    } else {
      const newList = { ...addPI }
      newList[name] = value
      setAddPI(newList)
    }
    setTimeout(() => setIsChanged(false), 10)
  }

  function handleItemChange(e, id) {
    const { name, value } = e.target

    setIsChanged(true)
    itemList[id][name] = value
    itemList[id].amount =
      itemList[id].qtyInput && itemList[id].price
        ? (
            parseFloat(itemList[id].qtyInput) * parseFloat(itemList[id].price)
          ).toString()
        : "0"
    setTimeout(() => setIsChanged(false), 1)
  }

  function handleAddNewRow() {
    const newItem = {
      id: "",
      name: "",
      qtyInput: "1",
      unit: "",
      price: "0",
      amount: "0",
      type: "",
      supplies_expense_id: "0",
    }
    setAdditionalItemList((oldItems) => [...oldItems, newItem])
  }

  function handleDelRow(id) {
    const newList = [...additionalItemList]
    newList.splice(id, 1)
    setAdditionalItemList(newList)
  }

  const [showLoader, setShowLoader] = useState(false)

  function handleAddTblChange(e, id) {
    const { name, value } = e.target
    var temp = additionalItemList

    if (name === "qtyInput" || name === "price") {
      setShowLoader(true)
      temp.map((item, index) => {
        var tempVal = value !== "" ? value : 0
        if (index === id) {
          item[name] = tempVal
          item.amount = parseFloat(item.qtyInput) * parseFloat(item.price)

          return item
        }
      })
    } else {
      temp.map((item, index) => {
        if (index === id) {
          item[name] = value
          return item
        }
      })
    }
    setAdditionalItemList(temp)
    setIsChanged(!isChanged)
    setTimeout(() => setShowLoader(false), 1)
  }

  async function handleCreatePI() {
    if (validateSePurchaseInvoice(addPI, itemList, setIsError)) {
      setIsClicked(true)
      addPI.attachments = fileList
      const response = await createSEPurchaseInvoice(
        addPI,
        itemList,
        additionalItemList,
        po_id
      )
      if (response.data) {
        toast.success(response.data.message, {
          style: toastStyle(),
        })
        setTimeout(
          () =>
            navigate(
              "/se/purchaseinvoices/print/" + response.data.supplies_receive_id
            ),
          1000
        )
      } else {
        response.error?.response?.data?.messages.map((data) => {
          return toast.error(data)
        })
      }
      setIsClicked(false)
    } else {
      toast.error("Please fill in all fields", { style: toastStyle() })
    }
    setTimeout(() => {}, 1000)
  }

  async function handleUpdatePI() {
    const allItems = []

    itemList.map((item) => {
      var info = item
      info.po_item_id = item.id
      info.qtyInput = item.qtyInput
      allItems.push(info)
    })
    if (additionalItemList.length > 0) {
      additionalItemList.map((item) => {
        var info = item
        info.qtyInput = item.qty
        info.po_item_id = "0"
        allItems.push(info)
      })
    }

    if (validateSePurchaseInvoice(addPI, itemList, setIsError)) {
      setIsClicked(true)
      addPI.attachments = fileList
      addPI.prev_files = prevAttachments
      const response = await updateSEPurchaseInvoice(addPI, allItems)

      if (response.data) {
        toast.success(response.data.message, {
          style: toastStyle(),
        })
        setTimeout(
          () => navigate("/se/purchaseinvoices/print/" + addPI.id),
          1000
        )
      } else if (response.error) {
        response.error?.response?.data?.messages.map((data) => {
          return toast.error(data)
        })
      }
    } else {
      toast.error("Please fill in all fields", { style: toastStyle() })
    }
    setTimeout(() => {
      setIsClicked(false)
    }, 5000)
  }

  const handleSubmit = () => {
    if (add) handleCreatePI()
    else if (edit) handleUpdatePI()
  }

  /** GET API - Branches **/
  async function fetchBranches() {
    const response = await getAllBranches()

    if (response.data) {
      var data = response.data.data
      data.map((branch) => {
        var info = {}

        info.name = "branch_id"
        info.label = branch.name
        info.value = branch.id
        setBranches((prev) => [...prev, info])
      })
    }
  }

  /** FOR ADD - Fetch Purchase Order Details */
  async function fetchPO() {
    setAddPI({})
    setItemList([])
    setIsChanged(true)

    const response = await getSingleSEPurchaseOrder(po_id)
    if (response.data) {
      var supplies_po = response.data.data[0]
      supplies_po.paid_amount =
        supplies_po.with_payment !== null ? supplies_po.grand_total : "0"
      supplies_po.received_date = getTodayDateISO()
      supplies_po.due_date = supplies_po.due_date || getTodayDateISO()
      supplies_po.purchase_date = supplies_po.supplies_expense_date
      supplies_po.invoice_no = supplies_po.invoice_no
      supplies_po.discount = supplies_po.discount ? supplies_po.discount : "0"
      supplies_po.service_fee = supplies_po.service_fee
        ? supplies_po.service_fee
        : "0"
      supplies_po.payment_status = "open"
      if (supplies_po.payment_status === "open") {
        supplies_po.is_vat = supplies_po.vat_type === "VAT" ? true : false
        supplies_po.withholding_percentage = parseInt(
          supplies_po.withholding_percentage
        )
        supplies_po.original_withholding_percentage = parseInt(
          supplies_po.withholding_percentage
        )
      } else {
        supplies_po.is_vat = false
        supplies_po.vat_type = "NVAT"
        supplies_po.withholding_percentage = 0
        supplies_po.original_withholding_percentage = 0
      }

      supplies_po.dr_no = ""
      var receivedItems = supplies_po.supplies_expense_items.map((item) => {
        var info = item
        info.amount = parseFloat(info.qty) * parseFloat(info.price)
        // info.qtyInput = item.qty;
        info.type = item.type || ""
        info.discount_percentage = item.discount_percentage || "0"
        info.discount_amount = item.discount_amount || "0"
        info.amount = item.total
        info.qtyInput = item.remaining_qty
        info.subtotal = item.total
        return info
      })
      setAddPI(supplies_po)
      setItemList(receivedItems)
      setForwarderValue({
        name: "forwarder_id",
        label: supplies_po.forwarder_name,
        value: supplies_po.forwarder_id,
      })
      setTypeValue({
        name: "type",
        label: capitalizeFirstLetter(supplies_po.type),
        value: supplies_po.type,
      })
      setTimeout(() => setIsChanged(false), 100)
    } else {
      TokenExpiry(response)
    }
  }

  console.log(itemList)

  /** FOR EDIT - Fetch Purchase Invoice Details */
  async function fetchPI() {
    const response = await getSingleSEPurchaseInvoice(pi_id)
    if (response.data) {
      var PI = response.data.data[0]
      setPrevAttachments(PI.supplies_receive_attachments)

      var itemsReceived = []
      var additionalReceived = []

      var itemReceivedTotal = 0
      var additionalReceivedTotal = 0

      if (PI.supplies_receive_items) {
        PI.receive_items = PI.supplies_receive_items.map((receive_item) => {
          var item = receive_item
          item.supplies_expense = receive_item.supplies_expense
          item.amount = receive_item.total
          item.qtyInput = receive_item.qty
          return item
        })

        PI.receive_items.map((receive_item) => {
          if (receive_item.supplies_expense !== "0") {
            itemReceivedTotal =
              itemReceivedTotal + parseFloat(receive_item.total)
            itemsReceived.push(receive_item)
          } else {
            receive_item.qtyInput = receive_item.qty
            additionalReceivedTotal =
              additionalReceivedTotal + parseFloat(receive_item.total)
            additionalReceived.push(receive_item)
          }
        })
      }

      PI.received_date = PI.supplies_receive_date
      PI.due_date = PI.due_date || moment().format("YYYY-MM-DD")
      PI.item_total = itemReceivedTotal
      PI.additional_item_total = additionalReceivedTotal
      PI.is_vat = PI.vat_type === "VAT" ? true : false
      PI.withholding_percentage = parseInt(PI.withholding_percentage)
      PI.original_withholding_percentage = parseInt(PI.withholding_percentage)
      setAddPI(PI)
      setItemList(itemsReceived)
      setAdditionalItemList(additionalReceived)
      setForwarderValue({
        name: "forwarder_id",
        label: PI.forwarder_name,
        value: PI.forwarder_id,
      })
      setTypeValue({
        name: "type",
        label: PI.type,
        value: PI.type,
      })
    }
  }

  async function fetchForwarders() {
    setForwarders([])

    const response = await getAllForwarders()
    var forwarders = response.data.data.sort((a, b) =>
      a.name > b.name ? 1 : b.name > a.name ? -1 : 0
    )

    forwarders.map((forwarder) => {
      var info = {}

      info.name = "forwarder_id"
      info.label = forwarder.name
      info.value = forwarder.id

      setForwarders((prev) => [...prev, info])
    })
  }

  // DATA FETCHING
  useEffect(() => {
    if (edit) {
      fetchPI()
    } else if (add) {
      fetchPO()
    }
    fetchForwarders()
    fetchBranches()
  }, [])

  // FOR DYNAMIC CALCULATION
  useEffect(() => {
    var calcSubtotal = 0
    var calcDiscountSubtotal = 0
    var tempDiscount = addPI.discount ? parseFloat(addPI.discount) : 0
    var tempServiceFee = addPI.service_fee ? parseFloat(addPI.service_fee) : 0

    if (itemList && !additionalItemList) {
      calcSubtotal = itemList
        .map((item) => parseFloat(item.amount))
        .reduce((a, b) => a + b, 0)
    } else if (!itemList && additionalItemList) {
      calcSubtotal = additionalItemList
        .map((item) => parseFloat(item.amount))
        .reduce((a, b) => a + b, 0)
    } else if (itemList && additionalItemList) {
      var itemListSubtotal = itemList
        .map((item) => parseFloat(item.amount))
        .reduce((a, b) => a + b, 0)
      var additionalItemListSubtotal = additionalItemList
        .map((item) => parseFloat(item.amount))
        .reduce((a, b) => a + b, 0)
      // item subtotal with discount per item
      calcSubtotal = itemListSubtotal + additionalItemListSubtotal
      // item subtotal with discount
      calcDiscountSubtotal = calcSubtotal - tempDiscount
    }

    var _wht = 0
    var vatable_sales = 0
    var vat = 0

    if (addPI.vat_type === "VAT") {
      vatable_sales = parseFloat(calcDiscountSubtotal) / 1.12
      vat = parseFloat(calcDiscountSubtotal) - vatable_sales
      var percentage =
        addPI?.withholding_percentage === 1
          ? 0.01
          : addPI?.withholding_percentage === 2
          ? 0.02
          : 0

      // witholding tax if vat is checked
      var tempVatSales = vatable_sales ? parseFloat(vatable_sales) : 0
      var tempWHTPercentage = percentage ? parseFloat(percentage) : 0
      _wht = parseFloat(tempVatSales) * tempWHTPercentage
    }
    var _grand_total_without_fee = calcDiscountSubtotal - _wht

    setAddPI((prev) => {
      return {
        ...prev,
        //   grand_total: calcSubtotal + tempServiceFee - tempDiscount,
        grand_total: _grand_total_without_fee + tempServiceFee,
        subtotal: calcSubtotal.toFixed(2),
        withholding_tax: _wht,
        discounted_subtotal: calcDiscountSubtotal.toFixed(2),
        grandtotal_without_service_fee: _grand_total_without_fee,
        vat: vat,
        vatable_sales: vatable_sales,
      }
    })
  }, [isChanged])

  //DISABLE SCROLL FUNCTION
  function limitScroll() {
    var numericInputs = document.querySelectorAll(".numeric-input")
    numericInputs.forEach(function (input) {
      input.addEventListener("wheel", function (e) {
        e.preventDefault()
      })
    })
  }
  limitScroll()

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"SUPPLIES"}
        />
      </div>

      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        {/* header */}
        <Row className="mb-4">
          <Col xs={12} lg={9}>
            <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2">
              {" "}
              {add ? "ADD " : "EDIT "}SUPPLIES EXPENSE INVOICE{" "}
            </h1>
            {/* <h5 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-5">Supplies Expense</h5> */}
          </Col>
          <Col xs={12} lg={3}>
            <span className="PI-header2">
              PURCHASE ORDER NO. {add ? po_id : addPI.supplies_expense_id}
            </span>
          </Col>
        </Row>

        {/* content */}
        <div className="edit-form">
          <Fragment>
            <Row>
              <Col xs={12} lg={6}>
                <span className="edit-label">Supplier Name</span>
                <Form.Control
                  type="text"
                  name="supplier_name"
                  className="nc-modal-custom-text"
                  defaultValue={
                    addPI.supplier_name
                      ? addPI.supplier_name
                      : addPI.supplier_trade_name
                      ? addPI.supplier_trade_name
                      : addPI.vendor_name
                      ? addPI.vendor_name
                      : addPI.vendor_trade_name
                  }
                  disabled
                />
              </Col>
              <Col xs={6} lg={2} className="mt-3 mt-lg-0">
                <span className="edit-label">Purchase Date</span>
                <Form.Control
                  type="date"
                  name="purchase_date"
                  className="nc-modal-custom-text"
                  defaultValue={addPI.purchase_date}
                  disabled
                />
              </Col>
              <Col xs={6} lg={2} className="mt-3 mt-lg-0">
                <span className="edit-label">Received Date</span>
                <Form.Control
                  type="date"
                  name="received_date"
                  className="nc-modal-custom-text"
                  defaultValue={addPI.received_date}
                  onChange={(e) => handleAddChange(e)}
                />
                <InputError
                  isValid={isError.received_date}
                  message={"Received date is required"}
                />
              </Col>
              <Col xs={12} lg={2} className="mt-3 mt-lg-0">
                <span className="edit-label">Due Date</span>
                <Form.Control
                  type="date"
                  name="due_date"
                  className="nc-modal-custom-text"
                  value={addPI.due_date}
                  onChange={(e) => handleAddChange(e)}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} lg={4} className="mt-3 mt-lg-0">
                {/* {add && ( */}
                <span className="edit-label">Branch</span>
                <Form.Control
                  type="text"
                  name="branch_name"
                  className="nc-modal-custom-text"
                  defaultValue={addPI.branch_name}
                  disabled
                />
                {/* )} */}
                {/* {edit && (
                                    <Select
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    placeholder="Select Branch..."
                                    value={branchValue}
                                    options={branches}
                                    onChange={(e) => handleBranchChange(e)}
                                />
                                )} */}
              </Col>
              <Col xs={12} lg={4} className="mt-3 mt-lg-0">
                <span className="edit-label">Forwarder</span>
                <Select
                  className="react-select-container"
                  classNamePrefix="react-select"
                  placeholder="Select Forwarder..."
                  value={forwarderValue}
                  options={forwarders}
                  onChange={(e) => handleForwarderChange(e)}
                />
              </Col>
              <Col xs={12} lg={4} className="mt-3 mt-lg-0">
                <span className="edit-label">
                  Type <label className="badge-required">{` *`}</label>
                </span>
                <Select
                  className="react-select-container"
                  classNamePrefix="react-select"
                  placeholder="Select type..."
                  value={typeValue}
                  options={typeOptions.sort((a, b) =>
                    a.value > b.value ? 1 : b.value > a.value ? -1 : 0
                  )}
                  onChange={(e) => handleType(e)}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} lg={4} className="mt-3 mt-lg-0">
                <span className="edit-label">Waybill No.</span>
                <Form.Control
                  type="text"
                  name="waybill_no"
                  className="nc-modal-custom-text"
                  value={addPI.waybill_no}
                  onChange={(e) => handleAddChange(e)}
                />
              </Col>
              <Col xs={12} lg={4} className="mt-3 mt-lg-0">
                <span className="edit-label">Invoice No.</span>
                <Form.Control
                  type="text"
                  name="invoice_no"
                  className="nc-modal-custom-text"
                  value={addPI.invoice_no}
                  onChange={(e) => handleAddChange(e)}
                />
                <InputError
                  isValid={isError.invoice_no}
                  message={"Either invoice no. or DR no. is required"}
                />
              </Col>
              <Col xs={12} lg={4} className="mt-3 mt-lg-0">
                <span className="edit-label">DR No.</span>
                <Form.Control
                  type="text"
                  name="dr_no"
                  className="nc-modal-custom-text"
                  value={addPI.dr_no}
                  onChange={(e) => handleAddChange(e)}
                />
                <InputError
                  isValid={isError.dr_no}
                  message={"Either invoice no. or DR no. is required"}
                />
              </Col>
            </Row>
          </Fragment>

          {/* RECEIVED ITEM TABLE */}
          <Row className="mt-4 pt-3">
            <Col>
              <span className="edit-label mb-2">Received Items</span>
              <div className="edit-purchased-items">
                {itemList.length !== 0 ? (
                  <Table>
                    <thead>
                      <tr>
                        <th>item</th>
                        <th>quantity</th>
                        <th>unit</th>
                        <th>unit price</th>
                        <th>total amount</th>
                        <th>ordered</th>
                        <th>previously received</th>
                        <th>balance</th>
                        <th>remarks</th>
                      </tr>
                    </thead>
                    <tbody>
                      {itemList.map((item, index) => {
                        return (
                          <tr>
                            <td>{item.name}</td>
                            <td>
                              <Form.Control
                                type="number"
                                min="0"
                                name="qtyInput"
                                className="hide-spinner numeric-input"
                                defaultValue={
                                  edit
                                    ? parseFloat(item.qty)
                                    : parseFloat(item.remaining_qty)
                                }
                                onChange={(e) => handleItemChange(e, index)}
                              />
                            </td>
                            <td>{item.unit}</td>
                            <td>
                              <Form.Control
                                type="number"
                                min="0"
                                name="price"
                                className="hide-spinner numeric-input"
                                defaultValue={parseFloat(item.price)}
                                onChange={(e) => handleItemChange(e, index)}
                              />
                            </td>
                            <td className="color-green">
                              PHP {numberFormat(item.amount)}
                            </td>
                            <td className="color-green">
                              {parseFloat(item.qty)}
                            </td>
                            <td className="color-green">
                              {parseFloat(item.received_qty) || "0"}
                            </td>
                            <td className="color-green">
                              {parseFloat(item.remaining_qty) || "0"}
                            </td>
                            {/* <td className="color-green">
                              {item.qty && item.received_qty
                                ? parseFloat(item.qty) -
                                  parseFloat(item.received_qty)
                                : "0"}
                            </td> */}
                            <td>
                              <Form.Control
                                type="text"
                                name="remarks"
                                placeholder="remarks"
                                className="hide-spinner numeric-input"
                                value={item.remarks}
                                onChange={(e) => handleItemChange(e, index)}
                              />
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </Table>
                ) : (
                  <div className="entries-not-found">
                    There is no received items recorded.
                  </div>
                )}
              </div>
            </Col>
          </Row>

          {/* ADDITIONAL PURCHASED ITEM TABLE */}
          <Row className="mt-4 pt-3">
            <Col>
              <span className="edit-label mb-2">
                Additional Purchased Items
              </span>
              <div className="edit-purchased-items">
                {additionalItemList.length !== 0 ? (
                  <Table>
                    <thead>
                      <tr>
                        <th className="color-gray">item</th>
                        <th className="color-gray">quantity</th>
                        <th className="color-gray">unit</th>
                        <th className="color-gray">unit price</th>
                        <th className="color-gray">amount</th>
                        <th className="color-gray">actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {additionalItemList.map((item, index) => {
                        return (
                          <tr>
                            <td>
                              <Form.Control
                                type="text"
                                name="name"
                                defaultValue={item.name}
                                onChange={(e) => handleAddTblChange(e, index)}
                              />
                            </td>
                            <td>
                              <Form.Control
                                type="number"
                                name="qtyInput"
                                className="hide-spinner numeric-input"
                                defaultValue={item.qtyInput}
                                onChange={(e) => handleAddTblChange(e, index)}
                              />
                            </td>
                            <td>
                              <Form.Control
                                type="text"
                                name="unit"
                                value={item.unit}
                                onChange={(e) => handleAddTblChange(e, index)}
                              />
                            </td>
                            <td>
                              <Form.Control
                                type="number"
                                name="price"
                                className="hide-spinner numeric-input"
                                defaultValue={item.price}
                                onChange={(e) => handleAddTblChange(e, index)}
                              />
                            </td>
                            <td className="color-green">
                              {item.qtyInput && item.price
                                ? numberFormat(item.price * item.qtyInput)
                                : "0.00"}
                            </td>
                            <td className="text-center">
                              <img
                                src={trash}
                                onClick={() => handleDelRow(index)}
                                className="cursor-pointer"
                                alt=""
                              />
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </Table>
                ) : (
                  <div className="entries-not-found">
                    There is no additional purchased items recorded yet.
                  </div>
                )}
              </div>
            </Col>
          </Row>

          {/* ADD ITEM BUTTON */}
          <Row className="pt-3 PO-add-item">
            <Col>
              <Button type="button" onClick={() => handleAddNewRow()}>
                Add Item
              </Button>
            </Col>
          </Row>

          {/* SUBTOTAL, FREIGHT COST, DISCOUNT, & GRAND TOTAL */}
          <Row className="align-right pt-3">
            <Col xs={8} className="text-end">
              <span className="edit-label color-gray">Subtotal</span>
            </Col>
            <Col xs={1} className="text-end">
              <span className="edit-label align-middle">PHP</span>
            </Col>
            <Col xs={3} className="text-end">
              <span className="edit-label align-middle">
                {numberFormat(addPI.subtotal)}
              </span>
            </Col>
          </Row>
          <Row className="align-right pt-3">
            <Col xs={8} className="text-end">
              <span className="edit-label color-gray">Discount</span>
            </Col>
            <Col xs={1} className="text-end">
              <span className="edit-label align-middle">PHP</span>
            </Col>
            <Col xs={3}>
              <Form.Control
                type="number"
                name="discount"
                value={addPI.discount}
                className="align-middle nc-modal-custom-text hide-spinner numeric-input"
                onChange={(e) => handleAddChange(e)}
              />
            </Col>
          </Row>
          <Row className="align-right pt-3">
            <Col xs={8} className="text-end">
              <span className="edit-label color-gray">Discounted Subtotal</span>
            </Col>
            <Col xs={1} className="text-end">
              <span className="edit-label align-middle">PHP</span>
            </Col>
            <Col xs={3} className="text-end">
              <span className="edit-label align-middle">
                {numberFormat(addPI.discounted_subtotal)}
              </span>
            </Col>
          </Row>
          <Row className="align-right pt-3">
            <Col xs={5} lg={6}></Col>
            <Col xs={3} lg={1} className="text-end print-table-footer-label">
              <Form.Group className="" controlId="formBasicCheckbox">
                <Form.Check
                  type="checkbox"
                  label="VAT"
                  name="is_vat"
                  className="pt-2"
                  checked={addPI.vat_type === "VAT"}
                  onChange={(e) => handleAddChange(e)}
                  disabled={addPI.payment_status === "closed" ? true : false}
                />
              </Form.Group>
            </Col>
            <Col xs={1} className="text-end">
              <span className="edit-label align-middle">PHP</span>
            </Col>
            <Col xs={3} className="text-end print-table-footer-data ps-4">
              {addPI.vat ? numberFormat(addPI.vat) : "0.00"}
            </Col>
          </Row>
          {addPI.vat_type === "VAT" && (
            <>
              <Row className="align-right pt-3">
                <Col xs={8} className="text-end print-table-footer-label">
                  Vatable Sales
                </Col>
                <Col xs={1} className="text-end">
                  <span className="edit-label align-middle">PHP</span>
                </Col>
                <Col xs={3} className="text-end print-table-footer-data ps-4">
                  {addPI.vatable_sales
                    ? numberFormat(addPI.vatable_sales)
                    : "0.00"}
                </Col>
              </Row>
              <Row className="align-right pt-3">
                <Col
                  xs={2}
                  lg={3}
                  className="text-end pt-2 print-table-footer-label"
                >
                  WHT
                </Col>
                <Col
                  xs={3}
                  lg={1}
                  className="text-end print-table-footer-label"
                >
                  <Form.Group className="" controlId="formBasicCheckbox">
                    <Form.Check
                      type="radio"
                      label="1%"
                      name="withholding_percentage"
                      value="1"
                      className="pt-2"
                      style={{ marginLeft: "2rem" }}
                      checked={addPI.withholding_percentage === 1}
                      onChange={(e) => handleAddChange(e)}
                      // disabled
                    />
                  </Form.Group>
                </Col>
                <Col
                  xs={3}
                  xl={1}
                  className="text-end print-table-footer-label"
                >
                  <Form.Group className="" controlId="formBasicCheckbox">
                    <Form.Check
                      type="radio"
                      label="2%"
                      name="withholding_percentage"
                      value="2"
                      className="pt-2"
                      style={{ marginLeft: "2rem" }}
                      checked={addPI.withholding_percentage === 2}
                      onChange={(e) => handleAddChange(e)}
                      // disabled
                    />
                  </Form.Group>
                </Col>
                <Col xs={1} className="text-end">
                  <span className="edit-label align-middle">PHP</span>
                </Col>
                <Col xs={3} className="text-end print-table-footer-data ps-4">
                  {addPI.withholding_tax
                    ? numberFormat(addPI.withholding_tax)
                    : "0.00"}
                </Col>
              </Row>
            </>
          )}
          <Row className="align-right pt-3">
            <Col xs={8} className="text-end">
              <span className="edit-label color-gray">Grand Total</span>
            </Col>
            <Col xs={1} className="text-end">
              <span className="edit-label align-middle">PHP</span>
            </Col>
            <Col xs={3} className="text-end">
              <span className="edit-label align-middle">
                {addPI.grandtotal_without_service_fee
                  ? numberFormat(addPI.grandtotal_without_service_fee)
                  : "0.00"}
              </span>
            </Col>
          </Row>
          <Row className="align-right pt-3">
            <Col xs={8} className="text-end">
              <span className="edit-label color-gray">
                Delivery/Service Fee
              </span>
            </Col>
            <Col xs={1} className="text-end">
              <span className="edit-label align-middle">PHP</span>
            </Col>
            <Col xs={3}>
              <Form.Control
                type="number"
                name="service_fee"
                value={addPI.service_fee}
                className="align-middle nc-modal-custom-text hide-spinner numeric-input"
                onChange={(e) => handleAddChange(e)}
              />
            </Col>
          </Row>
          <Row className="align-right pt-3">
            <Col xs={8} className="text-end">
              <span className="edit-label color-gray">TOTAL AMOUNT DUE</span>
            </Col>
            <Col xs={1} className="text-end">
              <span className="edit-label align-middle">PHP</span>
            </Col>
            <Col xs={3} className="text-end">
              <span className="edit-label align-middle">
                {numberFormat(addPI.grand_total)}
              </span>
            </Col>
          </Row>

          <Row className="mt-4 mb-2">
            <Col>
              <span className="edit-label">
                Remarks
                <span className="edit-optional px-2">(Optional)</span>
              </span>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Control
                as="textarea"
                name="remarks"
                value={addPI.remarks}
                className="nc-modal-custom-text"
                onChange={(e) => handleAddChange(e)}
              />
            </Col>
          </Row>

          {edit && (
            <>
              <div className="mt-4 noPrint mx-3">
                <Row className="review-data mb-2">FILE ATTACHMENTS</Row>
                <Row className="">
                  {prevAttachments &&
                    prevAttachments.map((attachment) => (
                      <Col
                        xs={1}
                        onClick={() => {
                          setPreviewFile(attachment.file_url)
                          setPreview(true)
                        }}
                        className="cursor-pointer preview-container"
                      >
                        <img
                          src={attachment.file_url}
                          className="img-preview"
                        />
                      </Col>
                    ))}
                  {!prevAttachments ||
                    (prevAttachments.length === 0 && (
                      <Col xs={1}>
                        <div className="no-data-cont d-flex justify-content-left preview-container">
                          <img
                            src={noDataImg}
                            alt="no data found"
                            className="img-preview"
                          />
                        </div>
                      </Col>
                    ))}
                </Row>
              </div>
            </>
          )}
          <Row className="mt-4 mb-2">
            <Col>
              <Dragger
                fileList={fileList}
                onRemove={handleRemove}
                beforeUpload={handleBeforeUpload}
                multiple={false}
                listType="picture"
                progress={{ showInfo: true }}
              >
                <img src={upload} className="cursor-pointer" />
                <p className="ant-upload-text">
                  Click or drag file to this area to upload
                </p>
              </Dragger>
            </Col>
          </Row>

          {/* FOOTER: CANCEL & SUBMIT BUTTONS */}
          <div className="d-flex justify-content-end pt-5 pb-3">
            <button
              type="button"
              className="button-secondary me-3"
              onClick={() => navigate("/se/purchaseinvoices")}
            >
              Cancel
            </button>
            {isClicked ? (
              <div className="button-primary d-flex justify-content-center">
                <ReactLoading
                  type="bubbles"
                  color="#FFFFFF"
                  height={50}
                  width={50}
                />
              </div>
            ) : (
              <button
                type="button"
                className="button-primary"
                onClick={handleSubmit}
              >
                Submit
              </button>
            )}
          </div>
        </div>
      </div>
      <Modal
        open={preview}
        title={""}
        footer={null}
        onCancel={() => setPreview(false)}
      >
        <Row className="justify-content-center">
          <img
            alt="example"
            style={{
              width: "100%",
            }}
            src={previewFile}
          />
          <div className="mt-2 d-flex justify-content-center">
            <img
              src={trash}
              alt="trash"
              onClick={() => handleRemoveItemAttachment(previewFile)}
              className="cursor-pointer"
            />
          </div>
        </Row>
      </Modal>
      <FileExceedModal
        show={showFileExceedModal}
        onHide={() => setShowFileExceedModal(false)}
        size="2MB"
      />
      <Footer />
    </div>
  )
}

SEFormPurchaseInvoice.defaultProps = {
  add: false,
  edit: false,
}

export default SEFormPurchaseInvoice
